import router from '../pc/router'
import install from '../pc';
import "../assets/styles/pc/index.scss";

!function (global) {
  dsf.performance.start("use平台所有组件")
  Vue.use(install);
  global.$platformRouter.pc.push(...router)
  dsf.performance.end("use平台所有组件")
}(dsf.global || (dsf.global = {}))
